import { render, staticRenderFns } from "./board-statistics1.vue?vue&type=template&id=d6e45e20&scoped=true&"
import script from "./board-statistics1.vue?vue&type=script&lang=js&"
export * from "./board-statistics1.vue?vue&type=script&lang=js&"
import style0 from "./board-statistics1.vue?vue&type=style&index=0&id=d6e45e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e45e20",
  null
  
)

export default component.exports